<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-card class="elevation-8">
          <v-toolbar :dark="$vuetify.theme.dark" color="primary">
            <v-toolbar-title>
              {{ $t('Системные настройки') }}
            </v-toolbar-title>
          </v-toolbar>
          <v-row
              v-for="task in tasks"
              :key="task.id"
              class="text-left pa-2 ma-2">
            <v-col v-if="isMainAdmin" class="align-self-center ml-2" cols="7">
              <validatable-checkbox
                  v-model="task.execute"
                  :label="task.description" />
            </v-col>
            <v-col v-if="task.model">
              <validatable-text-input
                  v-if="task.model.hasOwnProperty('interval')"
                  v-model="task.model.interval"
                  :rules="{ required: true,
                            max: 20,
                            regex: /^[0-9]{1,11}$/ }"
                  solo
                  :label="$t('Интервал (дни)')"
                  data-type="int" />
              <validatable-date-time-picker
                  v-if="task.model.hasOwnProperty('date')"
                  v-model="task.model.date"
                  :rules="{ required: true }"
                  :label="$t('Дата')" />
              <validatable-enum-combobox
                  v-if="task.model.hasOwnProperty('lotType')"
                  v-model="task.model.lotType"
                  dense
                  :label="$t('Тип лота')"
                  rules="required"
                  :values-enum="LOT_TYPE_ENUM" />
            </v-col>
          </v-row>
          <v-row v-if="!!generalError || isLoading" class="my-0 py-0 mx-1">
            <v-col cols="12">
              <v-progress-linear :active="isLoading" color="loader" indeterminate />
            </v-col>
            <v-col class="mx-1">
              <general-error v-if="!!generalError" />
            </v-col>
          </v-row>
          <v-row v-if="success" class="my-0 py-0 mx-1">
            <v-col cols="12">
              <v-alert
                  class="text-center"
                  outlined
                  :value="success"
                  type="success">
                {{ $t('Успешно выполнено') }}
              </v-alert>
            </v-col>
          </v-row>
          <v-card-actions>
            <v-btn
                id="saveBtn"
                v-test="{ btn: 'save' }"
                color="primary"
                :disabled="isLoading"
                @click.stop="execute">
              {{ $t('запустить') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import Vue from 'vue'
  import ValidatableCheckbox from '@/components/reused/ui/ValidatableCheckbox.vue'
  import ValidatableTextInput from '@/components/reused/ui/ValidatableTextInput.vue'
  import ValidatableEnumCombobox from '@/components/reused/ui/ValidatableEnumCombobox.vue'
  import ValidatableDateTimePicker from '@/components/reused/ui/ValidatableDateTimePicker.vue'
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import { LOT_TYPE_ENUM } from '@/constants/enums'
  import { mapActions } from 'vuex'
  import { SCHEDULER } from '@/constants/store.js'
  import store from '@/store'
  import scheduler from '@/store/dynamic/scheduler'
  const storeName = 'scheduler'
  export default {
    components: {
      ValidatableCheckbox,
      GeneralError,
      ValidatableTextInput,
      ValidatableEnumCombobox,
      ValidatableDateTimePicker
    },
    data () {
      return {
        LOT_TYPE_ENUM,
        isLoading: false,
        success: false,
        tasks: [
          {
            id: 'sendErrorsNotification',
            description: 'Информирование об ошибках в логах начиная с указанной даты',
            execute: false,
            method: this.sendErrorsNotificationAction,
            model: {
              date: this.$moment().utc().format()
            }
          },
          {
            id: 'sendAuthorizationDocumentExpirationDateNotification',
            description: 'Информирование о просроченных документах',
            execute: false,
            method: this.sendAuthorizationDocumentExpirationDateNotificationAction,
            model: {
              interval: 30
            }
          },
          {
            id: 'sendActivityStatisticsNotification',
            description: 'Информирование администраторов об оплате услуг, если была активность в СЭТ ВР',
            execute: false,
            method: this.sendActivityStatisticsNotificationAction
          }
        ]
      }
    },
    beforeCreate () {
      if (!store.hasModule(storeName)) {
        store.registerModule(storeName, scheduler)
      }
    },
    destroyed () {
      if (store.hasModule(storeName)) {
        store.unregisterModule(storeName)
      }
    },
    methods: {
      ...mapActions(SCHEDULER.NAMESPACE, {
        sendAuthorizationDocumentExpirationDateNotificationAction: SCHEDULER.ACTIONS.SEND_AUTHORIZATION_DOCUMENT_EXPIRATION_DATE_NOTIFICATION,
        sendErrorsNotificationAction: SCHEDULER.ACTIONS.SEND_ERRORS_NOTIFICATION,
        sendActivityStatisticsNotificationAction: SCHEDULER.ACTIONS.SEND_ACTIVITY_STATISTICS_NOTIFICATION
      }),
      execute: async function () {
        try {
          this.isLoading = true
          this.success = false
          const tasks = this.tasks.filter(t => t.execute)
          if (!tasks.length) {
            throw new Vue.errorsTypes.ValidationError(this.$t('Задачи не выбраны'))
          }
          await Promise.all(tasks.map(t => t.method(t.model || null)))
          this.success = true
        } catch (error) {
          this.throwIfUnknownError(error)
        } finally {
          this.isLoading = false
        }
      }
    }
  }
</script>
